import React from 'react';
import './PageHeaderTitle.less';

export const PageHeaderTitle = ({text}) => {
	return <span className="page-header-title">{text}</span>
}
